/** Compact empty state: icon, one sentence, and a valid next action when one exists. */
export const PortalEmptyState = ({ icon: Icon, title, description, action, testId = 'portal-empty-state' }) => (
  <div className="portal-empty-state" data-testid={testId}>
    {Icon && <Icon size={28} aria-hidden="true" className="portal-empty-state-icon" />}
    <p className="portal-empty-state-title">{title}</p>
    {description && <p className="portal-empty-state-description">{description}</p>}
    {action}
  </div>
);
